import React, { Component } from 'react';
import axios from "axios";

import api from '../../../api/';

import Create from "./Create.js"
import Edit from "./Edit.js"
import Delete from "./Delete.js"
import Detail from "./Detail.js"
import Activar from "./Activar.js"

import ParadigmaTable from "../../../components/ParadigmaTable/"


import moment from 'moment';
import Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import dateFunctions from '../../functions/dateFunctions';


class coeficientesue extends Component {
    constructor() {
        super();
        this.state = {
            columns: [
                {
                    Header: "id",
                    id: "pk",
                    accessor: "pk",
                    width: 100,
                    show: false,
                    private: true,
                },
                {
                    Header: "Fecha",
                    id: "fecha",
                    className: "text-center",
                    accessor: d => dateFunctions.parseDateTime(d.fecha),
                    show: true,
                    width: 150,
                    Filter: ({ filter, onChange }) =>
                        <Datetime
                            className="display-inline-block"
                            timeFormat="HH:mm"
                            dateFormat="DD/MM/YYYY"
                            closeOnSelect={true}
                            inputProps={{ name: 'startDate' }}
                            value={this.state.startDate}
                            onChange={
                                date => {
                                    this.setState({ startDate: date });
                                    onChange(moment(date).format('YYYY-MM-DD HH:mm'));
                                }
                            }
                        />

                },
                {
                    Header: "Nombre",
                    id: "nombre",
                    accessor: d => d.nombre,
                    show: true,
                },
                {
                    Header: "Valor",
                    id: "valor",
                    width: 100,
                    accessor: d => d.valor,
                    show: true,
                },
                {
                    Header: "Vigente",
                    id: "vigente",
                    width: 150,
                    className: "text-center",
                    accessor: d => (d.vigente ? <span className="badge badge-success">VIGENTE</span> : <div></div>),
                    show: true,
                },
            ]
        };
    }

    render() {
        const { data, pages, loading } = this.state;
        return (
            <ParadigmaTable
                buttons={[
                    {
                        create: true,
                        permission: 'coeficientesue_add',
                        component: Create,
                    },
                    {
                        edit: true,
                        permission: 'coeficientesue_edit',
                        component: Edit,
                    },
                    {
                        edit: true,
                        permission: 'coeficientesue_edit',
                        component: Activar,
                    },
                    {
                        detail: true,
                        permission: 'coeficientesue_detail',
                        component: Detail,
                    },
                    {
                        edit: true,
                        permission: 'coeficientesue_delete',
                        component: Delete,
                    }
                ]}

                apiUrl={api.proyectos.config.presupuesto.coeficientesue.list}
                columns={this.state.columns}
                exportUrl={api.proyectos.config.presupuesto.coeficientesue.export}
                title={"Coeficientes UE"}
                outerSort={[{"id":"nombre","desc":false}]}
            />
        );
    }
}

export default coeficientesue;



// WEBPACK FOOTER //
// ./src/views/ProyectosConfig/Presupuesto_CoeficientesUE/CoeficientesUE.js